module.exports = __webpack_public_path__ + "img/mountains-bg.96c15e32.png";